import React, { useState, useRef, useEffect } from "react";
import "../customCss/Login.css";
import Logo from "../images/sbg_logo.webp";
import { TextField } from "@mui/material";
import LoadingBar from "react-top-loading-bar";
import AuthService from "../services/auth.service";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Spinner from "../sections/Spinner";

const Login = () => {
  const ref = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    const auth = AuthService.getCurrentUser();
    if (auth) {
      navigate("/manage-profile");
    }
  }, [navigate]);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  useEffect(() => {
    document.title = "Officer App || Login";
    window.scrollTo(0, 0);
  }, []);
  const handleLogin = (e) => {
    e.preventDefault();
    setLoading(true);
    const trimmedUserName = userName.trim();
    const trimmedPassword = password.trim();
    if (trimmedUserName === "" || trimmedPassword === "") {
      toast.error("Username and password cannot be empty!");
      setLoading(false);
      return;
    }
    ref.current.continuousStart();
    AuthService.login(trimmedUserName, trimmedPassword)
      .then((response) => {
        if (response?.data?.accessToken) {
          setTimeout(() => {
            navigate("/manage-profile");
          }, 1000);
          toast.success("Logged In Successfully !!!");
          ref.current.complete();
          setLoading(false);
        } else {
          throw new Error("Login failed. Please check your credentials.");
        }
      })
      .catch((error) => {
        const resMessage = error?.response?.data?.message;
        toast.error(resMessage);
        setLoading(false);
        ref.current.complete();
      });
  };
  return (
    <>
      <LoadingBar color="#084e8a" ref={ref} height={5} />
      <div className="bg_sec">
        <div className="container logSecContainer">
          <div className="row logSecRow align-items-center justify-content-center">
            <div className="col-sm-5">
              <div className="loginOuter">
                <img src={Logo} className="main_logo mb-3" alt="main_logo" />
                <h1 className="mb-2 fw-bold">Admin Tools Panel</h1>
                <h2 className="mb-3">Login</h2>
                <hr />
                <form className="mt-4" onSubmit={handleLogin}>
                  <div className="mb-4">
                    <TextField
                      label="Username*"
                      variant="outlined"
                      fullWidth
                      value={userName}
                      onChange={(e) => setUserName(e.target.value)}
                    />
                  </div>
                  <div className="mb-4 position-relative">
                    <TextField
                      label="Password*"
                      variant="outlined"
                      type={showPassword ? "text" : "password"}
                      fullWidth
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <i
                      className={`fa ${
                        showPassword ? "fa-eye-slash" : "fa-eye"
                      }`}
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        fontSize: "20px",
                        right: 20,
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#333",
                      }}
                    />
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <button
                        className="btn btn-primary"
                        onClick={handleLogin}
                        disabled={loading}
                      >
                        {loading ? <Spinner /> : "Login"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
